import { render } from "./PlayPage.vue?vue&type=template&id=5444654c"
import script from "./PlayPage.vue?vue&type=script&lang=js"
export * from "./PlayPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__